import {IController, IModule, IOnChangesObject} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {changesInneholder} from "felles/stoettefunk/angularHjelpemetoder";
import {Kontekst} from "felles/tjenester/Kontekst";

const css = require('./forelder.scss');

export class ForelderKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
          .component('wkForelder', {
              bindings: {
                  forelderRef: '<',
                  forelderBeskrivelse: '<',
                  eiendeGruppeId: '<'
              },
              controller: ForelderKontroller.forInjisering(),
              template: require('./forelder.html'),
              transclude: true
          });
    }

    static forInjisering() {
        return [
            Kontekst.regNavn,
            ForelderKontroller
        ]
    }

    constructor(private kontekst: Kontekst) {
    }

    forelderRef: l.EntitetReferanseModell;
    forelderBeskrivelse: l.StrengMal<any>;
    eiendeGruppeId: string;

    gruppe: l.EnkelGruppeModell;

    gruppefarge() {
        if (!this.eiendeGruppeId) return '';
        return this.gruppe.farge;
    }

    $onChanges(endringer: IOnChangesObject): void {
        if (changesInneholder(endringer, 'eiendeGruppeId'))
            this.gruppe = this.kontekst.finnAutentiserteGruppe(this.eiendeGruppeId);
    }

}
